import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const deleteUpsellPage = {
  name: "deleteUpsellPage" as const,
  input: z.object({ upsellPageId: zExt.objectId() }),
  output: z.void(),
};
